// extracted by mini-css-extract-plugin
export default {"emotions-menu":"emotions-menu--bH7Qj","emotionsMenu":"emotions-menu--bH7Qj","overlay":"overlay--q5A3Z","menu":"menu--r_ilI","btn":"btn--vJuWt","icon":"icon--fK_j5"};